import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import vip from "../../images/market-place/vip.svg"
import mint from "../../images/market-place/mint.svg"
import volgai from "../../images/market-place/volgai_logo.jpg"
import volkslift from "../../images/market-place/volkslift.png"
import cornerston from "../../images/market-place/cornerston.svg"
import anconsult from "../../images/market-place/anconsult.png"
import cocalex from "../../images/market-place/cocalex.png"
import sweetNote from "../../images/market-place/sweet-note.svg"
import inpLogo from "../../images/market-place/inp-logo.png"
import collabartsLogo from "../../images/market-place/collabarts-logo.png"
import pisellLogo from "../../images/market-place/pisell-logo.png"
import ziiLogo from "../../images/market-place/zii_logo.png"
import jkkSolutionsLogo from "../../images/market-place/jkk_solutions_logo.png"
import sylaLogo from "../../images/market-place/syla-icon.png"
import kovaTaxSquareLogo from "../../images/market-place/kova-tax-square-logo.png"
import seederFinanceLogo from "../../images/market-place/seeder-finance.png"
import cfoLogo from "../../images/market-place/cfo-logo.png"
import targetAccoutingLogo from "../../images/market-place/target-accounting-logo.png"
import ozdLogo from "../../images/market-place/ozd_accounting_logo.jpg"
import financeMadeSimpleLogo from "../../images/market-place/finance_made_simple_logo.jpg"
import pinPointLocalLogo from "../../images/market-place/pinpoint-local_logo.png"
import usqLogo from "../../images/market-place/usq-logo.png"
import asaLogo from "../../images/market-place/asa-logo.png"
import timberM8Logo from "../../images/market-place/timber-m8-logo.png"

import Modali, { useModali } from "../modal"

const ITEMS_PER_PAGE = 9
const VISIBLE_CATEGORY_LIMIT = 8
const ALL_CATEGORIES_LABEL = "All categories"
const SEE_ALL_LABEL = "See all"
const SEE_LESS_LABEL = "See less"

const withProtocol = (url) => (/^https?:\/\//i.test(url) ? url : `https://${url}`)

const toTelHref = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`

/** Keeps the chip row short until the visitor expands it, without hiding the active filter. */
const getVisibleCategories = ({ categories, activeCategory, isExpanded }) => {
  if (isExpanded || categories.length <= VISIBLE_CATEGORY_LIMIT) return categories

  const collapsedCategories = categories.slice(0, VISIBLE_CATEGORY_LIMIT)
  if (!activeCategory || collapsedCategories.includes(activeCategory)) return collapsedCategories

  return [...collapsedCategories, activeCategory]
}

const ArrowRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 12h13m0 0-5-5m5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M7 3.5h3l1.5 4-2 1.5a12 12 0 0 0 5.5 5.5l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 5 5.7 2 2 0 0 1 7 3.5z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
  </svg>
)

const ShieldCheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3l7 3v5.5c0 4.2-2.9 7.6-7 9.5-4.1-1.9-7-5.3-7-9.5V6l7-3z" fill="currentColor" fillOpacity="0.18" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
const market_places = [
  {
    header_img: vip,
    category: "Cleaning Services",
    businessName: "MY VIP Cleaning",
    link: "https://myvipcleaningservice.com.au/",
    checkText1: "LUCA Pay",
    body: "We provide professional cleaning services for homes, offices, Industries & Events, etc. We have a team of leading trained cleaning professionals in Melbourne who work with full care and devotion to providing a neat"
  },
  {
    header_img: volgai,
    category: "Software & IT Services",
    businessName: "VolgAI",
    // imgClassName: "w-145px flex items-center",
    link: "https://volgai.com.au",
    checkText1: "LUCA Pay",
    body: "VolgAI is a managed IT services company supporting organizations with complex requirements to find solutions that span their entire businesses. We are based in Melbourne but our services aren’t confined to one single country."
  },
  {
    header_img: volkslift,
    category: "Building & Construction",
    businessName: "Volkslift Australia",
    // imgClassName: "w-145px min-h-100px flex items-center",
    link: "https://volkslift.au/",
    checkText1: "LUCA Pay",
    body: "Volkslift,Germany, established since 1935, is based in Cologne, Germany. Since the production of it’ s first passenger elevator, Volkslift remained here as the pioneer and market leader in the elevator industry of Europe."
  },
  {
    header_img: sweetNote,
    category: "Design",
    businessName: "Sweet Notes Studio",
    link: "https://sweetnotesstudio.com/",
    checkText1: "LUCA Pay",
    body: "We provide professional cleaning services for homes, offices, Industries & Events, etc. We have a team of leading trained cleaning professionals in Melbourne who work with full care and devotion to providing a neat"
  },
  {
    header_img: inpLogo,
    category: "Accounting & Business Consulting",
    businessName: "INP Group",
    // imgClassName: "w-133px",
    link: "https://www.inpgroup.com.au",
    checkText1: "LUCA Pay",
    body: "INP Group is a well-established chartered accounting firm with extensive experience across various sectors and different sizes of clients including listed companies and large private international businesses."
  },
  {
    header_img: collabartsLogo,
    category: "Design",
    businessName: "Collabarts",
    link: "https://www.collabarts.com.au",
    checkText1: "LUCA Pay",
    body: "Never worry about content anymore. Talk us through your brand and social media strategy and we will create the content that strategically communicates your brand values, personalities, mission and goals."
  },
  {
    header_img: pisellLogo,
    category: "Software & IT Services",
    businessName: "Pisel",
    // imgClassName: "w-145px min-h-105px flex items-center",
    link: "https://www.pisell.com/",
    checkText1: "LUCA Pay",
    body: "Pisell is a SaaS company dedicated to helping businesses find their customers, expand their online presence and improve efficiency in an all-round way. Founded in Australia, we are headquartered in Melbourne with offices all around Australia."
  },
  // {
  //   header_img: ziiLogo,
  //   imgClassName: "w-133px flex items-center min-h-105px",
  //   link: "https://www.ziicloud.com/",
  //   checkText1: "LUCA Pay",
  //   body: "We are a team of technologists, business builders and entrepreneurs who have come together to transform high street commerce into a connected and thriving digital ecosystem that creates value for all participants."
  // } ,
  {
    header_img: cfoLogo,
    category: "Accounting & Business Consulting",
    businessName: "Your CFO Partner",
    // imgClassName: "w-160px",
    link: "https://yourcfopartner.com.au/",
    checkText1: "LUCA Pay",
    body: "With 15 years experience working with construction business, Victor set up the business back in 2017. Since then, he is on a mission to help every construction business he touch to maximize profit margin and optimize cash flow."
  },
  {
    header_img: targetAccoutingLogo,
    category: "Accounting & Business Consulting",
    businessName: "Target Accounting",
    // imgClassName: "w-133px",
    link: "https://targetaccounting.com.au/",
    checkText1: "LUCA Pay",
    body: "As a CPA and Xero certified advisor I’ve served at all levels of the business world in the last 10 years. There is nothing more fulfilling than empowering business owners to take control of their financial situation."
  },
  {
    header_img: ozdLogo,
    category: "Accounting & Business Consulting",
    businessName: "OZD Accounting & Business Advisory",
    // imgClassName: "w-145px",
    link: "http://www.ozdadvisory.com.au/",
    checkText1: "LUCA Pay",
    body: "We facilitate and make accounting and finance easy.  We believe in building and nurturing trusting Relationships. We do this by providing, Honest advice, Independence, Accountability, Leadership."
  },
  {
    header_img: anconsult,
    category: "Accounting & Business Consulting",
    businessName: "Anconsult Business Solutions",
    // imgClassName: "w-145px",
    link: "https://anconsult.com.au/",
    checkText1: "LUCA Pay",
    body: "In 2012, Anja Carruthers opened the first office of Anconsult Business Solutions on the Central Coast of New South Wales. Back then, we operated as a BAS agent specialising in small businesses."
  },
  {
    header_img: financeMadeSimpleLogo,
    category: "Financial Consulting & Lending",
    businessName: "Finance Made Easy",
    imgWrapClassName: "financeLogo",
    link: "http://hofinancemadesimple.com.au/",
    checkText1: "LUCA Pay",
    body: "JBorrowing money for ventures such as buying your first home, purchasing an investment property or building a new home can be more complex than many people ..."
  },
  {
    header_img: pinPointLocalLogo,
    category: "Software & IT Services",
    businessName: "Pinpoint Local",
    // imgClassName: "w-24 flex items-center",
    link: "https://pinpointlocalbusiness.com.au/google-my-business-management-services/",
    checkText1: "LUCA Pay",
    body: "Convert local Google searchers into customers with your Google Business Profile (GBP). With Pinpoint Local’s GBP Management Service, you will unlock the power of..."
  },
  {
    header_img: asaLogo,
    category: "Building & Construction",
    businessName: "ASA Industry",
    imgClassName: "asaLogo",
    link: "www.asaindustry.com.au",
    checkText1: "LUCA Pay",
    body: "ASA Industry, established in 1991, specializes in designing and manufacturing automation systems.If you are after running your three-phase motor from a single-phase power supply or just simply controlling your three phase motors, we are here to help. Our wide range of custom design products can ensure that we meet all your requirements."
  },
  {
    header_img: usqLogo,
    category: "Accounting & Business Consulting",
    businessName: "USQ Ledgerbrains",
    imgClassName: "usqLogo",
    link: "https://www.unitedsq.com/",
    checkText1: "LUCA Pay",
    body: "USQ is an accounting firm with a true leading edge in digital accounting technology and commitment to innovation & disciplined entrepreurship by MIT. They have a young and vibrant team of business consultants, chartered accountants, tax advisors and bookkeepers. They don’t just provide accounting and business services, they reinvent and streamline business processes by providing their customers with custom-developed, “in-house” apps and software that help their customers operate their businesses, ranging from payroll automation software to accounts payable automations, online financial dashboard reporting and customer portal mobile app."
  },
  {
    header_img: cocalex,
    category: "Financial Consulting & Lending",
    businessName: "Cocalex",
    // imgClassName: "w-12 min-h-105px flex items-center",
    link: "https://www.cocalex.consulting/",
    checkText1: "LUCA Pay",
    body: "John has been a senior level executive within the lending and mortgage broking industry, having fulfilled a holistic repertoire of roles and projects in his 20 plus year career."
  },
  {
    header_img: jkkSolutionsLogo,
    category: "Financial Consulting & Lending",
    businessName: "JKK Solutions",
    // imgClassName: "w-145px flex items-center",
    link: "https://jkksolutions.com.au/",
    checkText1: "LUCA Pay",
    body: "JKK Solutions: Your Trusted Financial Partner JKK Solutions is an award-winning Mortgage Broking and Financial Services organization. We specialize in complex cashflow lending, property transactions, and investor portfolio lending. Our passion is helping our customers grow and succeed. Trust, respect, and creating value for each other are at the core of our values. Choose JKK Solutions for comprehensive finance solutions tailored to your needs. Contact us today to unlock your financial potential."
  },
  {
    header_img: sylaLogo,
    category: "Accounting & Business Consulting",
    businessName: "Syla",
    // imgClassName: "w-145px flex items-center",
    link: "https://www.syla.com.au/",
    checkText1: "LUCA Pay",
    body: "Meet Syla - Australia’s crypto tax software, created by a team of Australian tax professionals, exclusively for Australian crypto investors. Whether you’re an individual or SMSF, you can easily generate ATO-compliant tax reports that are optimised to save you tax."
  },
  {
    header_img: kovaTaxSquareLogo,
    category: "Accounting & Business Consulting",
    businessName: "Kova Tax",
    // imgClassName: "w-145px flex items-center",
    link: "https://kovatax.com.au/",
    checkText1: "LUCA Pay",
    body: "Kova Tax is a tech-driven accounting firm building a better digital world for businesses, SMSFs and investors in the cryptocurrency sector.We integrate technology and software at the core of our services so that we can work with you across all areas of cryptocurrency investment. Helping you to make more informed decisions, improve your tax-strategy and help you achieve the best outcome."
  },
  {
    header_img: seederFinanceLogo,
    category: "Financial Consulting & Lending",
    businessName: "Seeder Finance",
    // imgClassName: "w-145px flex items-center",
    link: "https://www.seederfinance.com.au/",
    checkText1: "LUCA Pay",
    body: "Are you self-employed and need help navigating the finance world? Seeder Finance is built off the back of nearly 15 years of business banking experience with one of Australia’s major banks. Our hallmark are the strong relationships we build with our clients to help them find the right solutions for them and their business"
  },{
    header_img: timberM8Logo,
    category: "Building Materials (Timber)",
    businessName: "Timber M8",
    link: "https://www.timberm8.com.au",
    phone: "0431 664 988",
    checkText1: "LUCA Pay",
    body: "TimberM8 — Melbourne's online timber retailer, delivering fresh structural, decking, and landscaping timber straight from wholesale to your site, at competitive prices."
  },
]

export const categoryOptions = Array.from(new Set(market_places.map((place) => place.category))).sort()

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState(null)
  const [showAllCategories, setShowAllCategories] = useState(false)
  const [currentItems, setCurrentItems] = useState(null)
  const [pageCount, setPageCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const [contactModal, toggleContactModal] = useModali()
  const [placeObject, updatePlaceObject] = useState({})

  const filteredPlaces = activeCategory
    ? market_places.filter((place) => place.category === activeCategory)
    : market_places

  const isCategoryListCollapsible = categoryOptions.length > VISIBLE_CATEGORY_LIMIT
  const visibleCategories = getVisibleCategories({
    categories: categoryOptions,
    activeCategory,
    isExpanded: showAllCategories,
  })

  const openBusiness = (place) => {
    updatePlaceObject(place)
    toggleContactModal()
  }

  const handleCategoryClick = (category) => {
    setActiveCategory(category)
    setItemOffset(0)
    setCurrentPage(0)
  }

  useEffect(() => {
    const endOffset = itemOffset + ITEMS_PER_PAGE
    setCurrentItems(filteredPlaces.slice(itemOffset, endOffset))
    setPageCount(Math.ceil(filteredPlaces.length / ITEMS_PER_PAGE))
  }, [itemOffset, activeCategory])

  const handlePageClick = (event) => {
    const newOffset = (event.selected * ITEMS_PER_PAGE) % filteredPlaces.length
    setCurrentPage(event.selected)
    setItemOffset(newOffset)
  }

  return (
    <div className="container">
      <div className="categories">
        <div className="business-wrap paginate">
          <div className="category-bar">
            <span className="category-bar__label">Categories</span>
            <div className="category-bar__chips">
              <button
                type="button"
                className={`category-chip ${!activeCategory ? "category-chip--active" : ""}`}
                onClick={() => handleCategoryClick(null)}
              >
                {ALL_CATEGORIES_LABEL}
              </button>
              {visibleCategories.map((category) => (
                <button
                  key={category}
                  type="button"
                  className={`category-chip ${activeCategory === category ? "category-chip--active" : ""}`}
                  onClick={() => handleCategoryClick(category)}
                >
                  {category}
                </button>
              ))}
              {isCategoryListCollapsible && (
                <button
                  type="button"
                  className="category-chip category-chip--toggle"
                  onClick={() => setShowAllCategories((isExpanded) => !isExpanded)}
                >
                  {showAllCategories ? SEE_LESS_LABEL : SEE_ALL_LABEL}
                  <ArrowRightIcon />
                </button>
              )}
            </div>
          </div>

          <div className="supplier-grid">
            {currentItems && currentItems.length === 0 && (
              <div className="no-results">No suppliers found in this category.</div>
            )}
            {currentItems &&
              currentItems.map((place) => (
                <article key={place.businessName} className="supplier-card">
                  <div className="supplier-card__logo">
                    <img src={place.header_img} className={place.imgClassName || ""} alt={place.businessName} />
                  </div>
                  <div className="supplier-card__body">
                    <span className="supplier-card__tag">{place.category}</span>
                    <h3 className="supplier-card__name">{place.businessName}</h3>
                    <p className="supplier-card__description">{place.body}</p>
                    {place.phone && (
                      <a className="supplier-card__phone" href={toTelHref(place.phone)}>
                        {place.phone}
                      </a>
                    )}
                    <div className="supplier-card__badges">
                      <span className="supplier-badge">
                        <ShieldCheckIcon />
                        {place.checkText1}
                      </span>
                    </div>
                    <button type="button" className="supplier-card__cta" onClick={() => openBusiness(place)}>
                      View business
                      <ArrowRightIcon />
                    </button>
                  </div>
                </article>
              ))}
          </div>

          <ReactPaginate
            breakLabel="..."
            nextLabel=" >"
            onPageChange={handlePageClick}
            marginPagesDisplayed={0}
            pageRangeDisplayed={2}
            pageCount={pageCount}
            forcePage={currentPage}
            previousLabel="< "
            renderOnZeroPageCount={null}
          />

          <Modali.Modal {...contactModal} hubspot={true} showLogo={false} className=" business-modal">
            {placeObject.businessName ? (
              <div className="business-modal__inner">
                <div className="business-modal__header">
                  <div className="business-modal__logo">
                    <img src={placeObject.header_img} alt={placeObject.businessName} />
                  </div>
                  <div className="business-modal__identity">
                    <span className="business-modal__category">{placeObject.category}</span>
                    <h3 className="business-modal__name">{placeObject.businessName}</h3>
                    <span className="supplier-badge">
                      <ShieldCheckIcon />
                      {placeObject.checkText1}
                    </span>
                  </div>
                </div>
                <div className="business-modal__body">
                  <p className="business-modal__description">{placeObject.body}</p>
                  {placeObject.phone && (
                    <a className="business-modal__phone" href={toTelHref(placeObject.phone)}>
                      <PhoneIcon />
                      {placeObject.phone}
                    </a>
                  )}
                  <a
                    href={withProtocol(placeObject.link)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="modal-visit-link"
                  >
                    Visit website
                    <ArrowRightIcon />
                  </a>
                </div>
              </div>
            ) : null}
          </Modali.Modal>
        </div>
      </div>
    </div>
  )
}
